import { apiFetch } from './client';
import type { Doc } from '$lib/types';

export const docsApi = {
  forProject: (projectId: number) => apiFetch<{ results: Doc[]; count: number }>(`/projects/${projectId}/docs`),
  get: (id: number) => apiFetch<Doc>(`/docs/${id}`),
  // Admin-only writes; members are read-only.
  create: (projectId: number, body: { title: string; body: string }) =>
    apiFetch<Doc>(`/projects/${projectId}/docs`, { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: { title: string; body: string }) =>
    apiFetch<Doc>(`/docs/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  remove: (id: number) => apiFetch<{ detail: string }>(`/docs/${id}`, { method: 'DELETE' })
};
